import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, LogIn, User } from 'lucide-react';

const AuthButton = ({ variant = 'nav', onAction }) => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
    onAction?.();
  };

  const handleLogin = () => {
    navigate('/login');
    onAction?.();
  };

  if (variant === 'menu') {
    if (isAuthenticated) {
      return (
        <div className="space-y-3">
          <div className="flex items-center gap-3 px-3 py-2 rounded-xl bg-white border border-gray-200">
            <div className="flex items-center justify-center h-9 w-9 rounded-full bg-blue-100 text-blue-700">
              <User className="h-4 w-4" />
            </div>
            <div className="min-w-0">
              <p className="text-xs text-gray-500">Sesión iniciada</p>
              <p className="text-sm font-semibold text-gray-800 truncate">{user?.username}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-red-600 bg-red-50 hover:bg-red-100 border border-red-100 transition-colors font-medium"
          >
            <LogOut className="h-4 w-4" />
            Cerrar sesión
          </button>
        </div>
      );
    }

    return (
      <button
        onClick={handleLogin}
        className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition-colors font-medium shadow-sm"
      >
        <LogIn className="h-4 w-4" />
        Iniciar sesión
      </button>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="flex items-center gap-2">
        <span className="hidden xl:inline text-sm text-blue-100/90 max-w-[120px] truncate">
          {user?.username}
        </span>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-blue-100 hover:bg-white/10 hover:text-white transition-colors"
          title="Cerrar sesión"
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden xl:inline text-sm">Salir</span>
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={handleLogin}
      className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-blue-100 hover:bg-white/10 hover:text-white transition-colors"
      title="Iniciar sesión"
    >
      <LogIn className="h-4 w-4" />
      <span className="hidden xl:inline text-sm">Entrar</span>
    </button>
  );
};

export default AuthButton;
